import React, { useEffect, useState } from "react";
import { Button, TextField } from "@mui/material";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import CloseIcon from "@mui/icons-material/Close";
import DatePickerWithTimeComponent from "../DatePickerWithTimeComponent";
import { useAuth } from "../../contexts/AuthContext";
import { db } from "../../firebase";
import { addDoc, collection, serverTimestamp, doc, updateDoc } from "firebase/firestore";
import { toast } from "react-toastify";

import Chip from "@mui/material/Chip";
import { getDownloadURL, getStorage, ref, uploadBytes } from "firebase/storage";
import UploaderDocForNote from "../Updloader/UploaderDocForNote";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DescriptionIcon from "@mui/icons-material/Description";
import ImageIcon from "@mui/icons-material/Image";
import AudiotrackIcon from "@mui/icons-material/Audiotrack";
import MovieCreationIcon from "@mui/icons-material/MovieCreation";
import FolderZipIcon from "@mui/icons-material/FolderZip";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";

function AddTherapyNote(props) {

  const { currentUser } = useAuth();

  //Tous les states des données récupérées par client

  const [isLoading, setIsLoading] = useState(false);

  const [therapyNote, setTherapyNote] = useState("");
  const [therapyNoteDateTime, setTherapyNoteDateTime] = useState(new Date());
  const [files, setFiles] = useState([]);
  const draftKey = `draft:therapyNote:${currentUser?.uid || "anon"}:${
    props.clientId || "unknown"
  }`;
  const draftDelay = 800;
  const [isSavingDraft, setIsSavingDraft] = useState(false);

  const handleTherapyNoteChange = (event) => {
    setTherapyNote(event.target.value);
  };

  const handleDateTimeChange = (event) => {
    setTherapyNoteDateTime(event);
  };

  // useEffect(() => {
  //   recordMetrics("Notes", "therapyNotes", currentUser.email, "write", "bodhi");
  // }, []);

  const getFileIcon = (name = "") => {
    const ext = name.split(".").pop()?.toLowerCase();
    if (["pdf"].includes(ext)) return <PictureAsPdfIcon sx={{ color: "#d32f2f" }} />;
    if (["png", "jpg", "jpeg", "gif", "bmp", "webp"].includes(ext))
      return <ImageIcon sx={{ color: "#1976d2" }} />;
    if (["mp3", "wav", "aac", "ogg", "m4a"].includes(ext))
      return <AudiotrackIcon sx={{ color: "#8e24aa" }} />;
    if (["mp4", "mov", "avi", "mkv", "webm"].includes(ext))
      return <MovieCreationIcon sx={{ color: "#6d4c41" }} />;
    if (["zip", "rar", "7z"].includes(ext)) return <FolderZipIcon sx={{ color: "#f57c00" }} />;
    if (["doc", "docx", "xls", "xlsx", "ppt", "pptx", "txt", "csv"].includes(ext))
      return <DescriptionIcon sx={{ color: "#2e7d32" }} />;
    return <InsertDriveFileIcon sx={{ color: "#607d8b" }} />;
  };

  const handleFileChange = (event) => {
    const selectedFiles = Array.from(event.target.files || []);
    const filtered = selectedFiles.filter((f) => f.size <= 50 * 1024 * 1024);
    const rejected = selectedFiles.filter((f) => f.size > 50 * 1024 * 1024);
    if (rejected.length) {
      toast.error("Some files exceed 50MB and were skipped.");
    }
    setFiles((prev) => [...prev, ...filtered]);
  };

  const uploadFilesAndGetUrls = async (docId) => {
    if (!files.length) return [];
    const storage = getStorage();
    const fileUrls = [];
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const prefix = props.clientId ? `clients/${props.clientId}` : "therapyNotes";
      const filePath = `Documents/${prefix}/${docId}/${file.name}`;
      const storageRef = ref(storage, filePath);
      await uploadBytes(storageRef, file);
      const fileUrl = await getDownloadURL(storageRef);
      fileUrls.push({ url: fileUrl, name: file.name });
    }
    return fileUrls;
  };

  const handleAddTherapyNote = async (note, clientID, effectiveDateTime) => {
    const noteData = {
      noteType: "therapyNote",
      noteContent: note,
      clientId: clientID,
      createdAt: serverTimestamp(),
      effectiveDateTime: effectiveDateTime,
      doneBy: currentUser.displayName,
      clientFirstName: props.firstName,
      clientLastName: props.lastName,
      clientProfilePicture: props.profilePicture || "",
    };

    if (therapyNote && therapyNoteDateTime) {
      setIsLoading(true);
      try {
        const docRef = await addDoc(collection(db, "notes"), noteData);
        const fileUrls = await uploadFilesAndGetUrls(docRef.id);
        if (fileUrls.length) {
          await updateDoc(doc(db, "notes", docRef.id), { fileUrls });
        }
        toast.success(`Therapy note successfully added!`, {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        setIsLoading(false);
        try {
          localStorage.removeItem(draftKey);
        } catch {}
        setFiles([]);
        props.closemodal();
      } catch (error) {
        console.log("error adding note :", error);
        toast.error(`Problem when adding note`, {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }
    } else {
      toast.error(`Some mandatory fields are empty. Please check.`, {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    }
  };

  const handleSubmit = () => {
    handleAddTherapyNote(therapyNote, props.clientId, therapyNoteDateTime);
  };

  // Restore draft on mount
  useEffect(() => {
    try {
      const raw = localStorage.getItem(draftKey);
      if (raw) {
        const parsed = JSON.parse(raw);
        if (parsed?.text) setTherapyNote(parsed.text);
        if (parsed?.date) {
          const d = new Date(parsed.date);
          if (!isNaN(d)) setTherapyNoteDateTime(d);
        }
      }
    } catch (e) {
      console.warn("TherapyNote draft load error:", e);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Autosave draft with debounce
  useEffect(() => {
    const t = setTimeout(() => {
      try {
        localStorage.setItem(
          draftKey,
          JSON.stringify({
            text: therapyNote,
            date: therapyNoteDateTime?.toISOString?.() || null,
          })
        );
        setIsSavingDraft(false);
      } catch (e) {
        console.warn("TherapyNote draft save error:", e);
      }
    }, draftDelay);
    setIsSavingDraft(true);
    return () => clearTimeout(t);
  }, [therapyNote, therapyNoteDateTime, draftKey]);

  return (
    <>
      <div
        style={{ width: "auto", height: "100%" }}
        className="inputAndLabelModalContainerTitle2"
      >
        <div className="line1-modal-percent">
          <div className="modal-title" style={{ paddingLeft: "10px" }}>
            Add 1 to 1 therapy session note
          </div>
          <CloseIcon
            style={{
              marginRight: "16px",
              color: "rgb(214, 213, 213)",
              cursor: "pointer",
            }}
            onClick={props.closemodal}
          />
        </div>

        <div
          style={{
            width: "100%",
            marginTop: "0px",
            height: "75%",
            overflowY: "scroll",
            overflowX: "hidden",
          }}
        >
          <div
            className="line2-column-modal"
            style={{
              paddingLeft: "10px",
              // backgroundColor: "pink",
            }}
          >
            <div
              className="label-textfield"
              style={{ paddingLeft: "15px", paddingBottom: "5px" }}
            >
              Note content
            </div>
            <TextField
              value={therapyNote}
              onChange={handleTherapyNoteChange}
              style={{
                width: "95%",
                borderRadius: "5px",
                backgroundColor: "#f2eeef",
              }}
              placeholder="Type 1 to 1 therapy session note here"
              multiline
              rows={14}
            />
          </div>
          <div
            style={{
              background: "#fff",
              border: "1px dashed #cbd5e1",
              borderRadius: 10,
              padding: 12,
              marginLeft: "10px",
              marginRight: "10px",
              marginTop: 12,
            }}
          >
            <div style={{ fontWeight: 600, marginBottom: 8 }}>Attachments</div>
            {files?.length ? (
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
                  gap: 8,
                  marginBottom: 8,
                }}
              >
                {files.map((f, idx) => (
                  <div
                    key={idx}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      padding: "8px 10px",
                      borderRadius: 8,
                      border: "1px solid #e5e7eb",
                      background: "#f8fafc",
                    }}
                  >
                    {getFileIcon(f.name)}
                    <div style={{ fontSize: 13, color: "#111" }}>{f.name}</div>
                  </div>
                ))}
              </div>
            ) : (
              <div style={{ fontSize: 12, color: "#666", marginBottom: 8 }}>
                No files selected
              </div>
            )}
            <UploaderDocForNote handleFileChange={handleFileChange} files={files} />
            <div style={{ fontSize: 12, color: "#666", marginTop: 4 }}>
              Max file size: 50 MB each.
            </div>
          </div>
          <div
            className="line3-modal-percent"
            style={{
              // marginLeft: "20px",
              paddingLeft: "30px",
              paddingTop: "10px",
              marginBottom: "20px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <DatePickerWithTimeComponent
              title="Effective date and time"
              value={therapyNoteDateTime}
              onChange={handleDateTimeChange}
            />
          </div>
        </div>
        <div
          className="line4-modal-percent"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            gap: 10,
          }}
        >
          <Chip
            label={
              isSavingDraft
                ? "Saving draft..."
                : therapyNote
                ? "Draft saved"
                : "No draft"
            }
            size="small"
            sx={{
              backgroundColor: isSavingDraft
                ? "#f9a825"
                : therapyNote
                ? "#2e7d32"
                : "#607d8b",
              color: "#fff",
              fontWeight: 700,
            }}
          />
          <Button
            variant="outlined"
            size="small"
            onClick={() => {
              try {
                localStorage.removeItem(draftKey);
              } catch {}
              setTherapyNote("");
              setTherapyNoteDateTime(new Date());
              setFiles([]);
            }}
          >
            Clear draft
          </Button>
          <Button
            variant="contained"
            style={{ backgroundColor: "white", color: "black" }}
            onClick={props.closemodal}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            style={
              isLoading
                ? {
                    backgroundColor: "red",
                    color: "white",
                    marginLeft: "15px",
                  }
                : {
                    backgroundColor: "#1565C0",
                    color: "white",
                    marginLeft: "15px",
                  }
            }
            disabled={isLoading}
            onClick={handleSubmit}
          >
            {isLoading ? "ADDING NOTE..." : "ADD NOTE"}
          </Button>
        </div>
      </div>
    </>
  );
}

export default AddTherapyNote;
